import Banner from "../../Assets/Images/Auxzn banner.jpg";

const blogsData = [
  {
    id: 1,

    title: "Future of Blow Molding Industry",   

    description:
      "Discover the latest innovations and trends in the blow molding industry.",

    image: Banner ,

    path: "/blogs/future-of-blow-molding",
  },
];

export default blogsData;
